/**
 * User: nir
 * Date: 22/09/2016
 * Time: 17:38
 */

window.TCT = window.TCT || {};
window.TCT.JWPlayer = window.TCT.JWPlayer || {
        setTargetingParams: function (playlistItem) {
            // get the player
            var player = this;
            if (player && playlistItem && window['TCTTargeting']) {
                // copy all targeting parameters to the playlist item
                for (var key in TCTTargeting) {
                    if (TCTTargeting.hasOwnProperty(key)) {
                        var value = TCTTargeting[key];
                        playlistItem[key] = value instanceof Array ? value.join(',') : value;
                    }
                }
            }
            if (TCT && TCT.debug) TCT.debug('JWPlayer Ad Targeting:', playlistItem);
        },
        afterPlayerSetup: function () {
            var player = window['jwplayer']();
            if (!player) return;
            // bind event handlers
            // player.on('all', function log(ev) {
            //     TCT.debug('Video player event', arguments);
            // });

            player.on('playlistItem', function setVideoTargeting(data) {
                var item = (!!data && !!data.item) ? data.item : null;
                if (!item) item = player.getPlaylistItem();
                if (!item) return;
                if (TCT && TCT.JWPlayer) {
                    TCT.JWPlayer.setTargetingParams(item);
                }
            });

            var item = null,
                firstTimePlay=true;

            if (!player) return;

            function trackPlay(data) {
                if (!item || !item.mediaid) return;
                if (!data || !data.playReason) return;

                var func = data.playReason === 'autostart' ? trackCTANoInteraction : trackCTA,
                    seAction=firstTimePlay?'video_play':'video_resume';
                firstTimePlay=false;
                func(seAction, item.mediaid);
            }

            function trackPlaylistItem(data) {
                if (!data || !data.item) return;
                item = data.item; // SUPER IMPORTANT - DO NOT DELETE!
                TCT.debug('Playlist item:', item);
                firstTimePlay=true;
            }

            // function trackProgress(data) {
            //     if (!data || !data.position) return;
            //     trackCTANoInteraction('video_progress', data.position.toString());
            // }

            function trackPause() {
                var pos = player.getPosition();
                if (!pos) return;
                trackCTA('video_pause', pos.toString());
            }

            function trackComplete() {
                trackCTANoInteraction('video_complete');
            }

            function trackSetupError(ev) {
                trackCTANoInteraction('video_setup_error', ev && ev.message ? ev.message : '-');
            }

            function trackError(ev) {
                trackCTANoInteraction('video_error', ev && ev.message ? ev.message : '-');
            }

            function trackAdError(ev) {
                var data = [
                    ev && ev.message ? ev.message : null,
                    ev && ev.tag ? ev.tag : null
                ];

                trackCTANoInteraction('video_ad_error', data.filter(function (e) { return !!e; }).join('@'));
            }

            // bind event handlers
            player
            // .on('all', log)
                .on('play', trackPlay)
                .on('playlistItem', trackPlaylistItem) // SUPER IMPORTANT - DO NOT DELETE!
                // .on('time', trackProgress)
                .on('pause', trackPause)
                .on('complete', trackComplete)
                .on('setupError', trackSetupError)
                .on('adError', trackAdError)
                .on('error', trackError);

        }
    };